(function ($) {
  $(document).ready(function ($) {
    if ($("body.product").length) {
      gsap.registerPlugin(ScrollTrigger);

      // Product Images on PDP page
      // –> Initialize carousel immediately for faster LCP, lazy images load as needed
      // ---
      var $mainProductCarousel = $(".main-product-carousel.owl-carousel");
      var $firstImage = $mainProductCarousel.find(".product-image img").first();

      function initializeCarousel() {
        $mainProductCarousel.owlCarousel({
          autoplay: false,
          items: 1,
          singleItem: true,
          rewind: true,
          rewindNav: true,
          rewindSpeed: 0,
          autoHeight: true,
          nav: false,
          dots: true,
          lazyLoad: true,
          responsive: {
            950: {
              dots: false,
              mouseDrag: false,
              nav: true,
              navText: [
                '<span class="visually-hidden">Click to view the previous product image</span><svg xmlns="http://www.w3.org/2000/svg" width="41.362" height="28.51" viewBox="0 0 41.362 28.51" aria-hidden="true"><g transform="scale(-1, 1) translate(-41.362, 0)"><path d="M-1.475,20.694H38.076M24.882,7.5,38.076,20.694,24.882,33.889" transform="translate(2.225 -6.439)" fill="none" stroke="#19262f" stroke-linecap="round" stroke-width="1.5"/></g></svg>',
                '<span class="visually-hidden">Click to view the next product image</span><svg xmlns="http://www.w3.org/2000/svg" width="41.362" height="28.51" viewBox="0 0 41.362 28.51" aria-hidden="true"><path d="M-1.475,20.694H38.076M24.882,7.5,38.076,20.694,24.882,33.889" transform="translate(2.225 -6.439)" fill="none" stroke="#19262f" stroke-linecap="round" stroke-width="1.5"/></svg>',
              ],
            },
          },
        });
      }

      // Initialize carousel once first image is ready (for proper height calc)
      // If first image is already loaded, init immediately
      if ($firstImage.length && $firstImage[0].complete) {
        initializeCarousel();
      } else if ($firstImage.length) {
        $firstImage.on("load", initializeCarousel);
      } else {
        // No images, init anyway
        initializeCarousel();
      }
      // ---
      // END – Product Images on PDP page

      // Scrolling Call to Action Button
      // ---
      var $scrollAtc = $("#scroll-cta"),
        $pdpAtc = $("#pdp-only-atc"),
        $footer = $("#footer");

      // Original functionality with #pdp-only-atc
      gsap.to($scrollAtc, {
        scrollTrigger: {
          trigger: $pdpAtc,
          start: "top bottom",
          end: "bottom top",
          onLeave: () => $scrollAtc.addClass("show"),
          onEnterBack: () => $scrollAtc.removeClass("show"),
          scrub: true,
        },
      });

      gsap.to($scrollAtc, {
        scrollTrigger: {
          trigger: $footer,
          start: "top bottom",
          onEnter: () => $scrollAtc.removeClass("show"),
          onLeaveBack: () => $scrollAtc.addClass("show"),
          scrub: true,
        },
      });

      // When $scrollAtc is clicked, trigger a click on $pdpAtc
      $scrollAtc.on("click", function () {
        $pdpAtc.trigger("click");
      });
      // ---
      // END – Scrolling Call to Action Button

      // Responsive
      // set the pinning up for the product hero on tablet or larger screens
      // ---
      ScrollTrigger.matchMedia({
        "(min-width: 768px)": function () {
          // tabs / how to use content toggling
          $(".tab-button-wrap").children().first().addClass("active");
          $(".tab-content-wrap").children().first().addClass("active");
          $("button.tab").click(function (event) {
            if ($(this).hasClass("active")) {
              return;
            }

            var tabIndex = $(this).index(),
              tabs = $(".tab-button-wrap").children(),
              tabContent = $(".tab-content-wrap").children();

            tabs.removeClass("active").attr("aria-expanded", "false");
            tabContent.removeClass("active").attr("aria-hidden", "true");

            $(tabs[tabIndex]).addClass("active").attr("aria-expanded", "true");
            $(tabContent[tabIndex]).addClass("active").attr("aria-hidden", "false");
          });
        },
      });
      // ---
      // END Responsive

      gsap.to(".product-hero", {
        scrollTrigger: {
          trigger: ".product-hero",
          start: "bottom bottom",
          end: "bottom top",
          pin: ".product-hero",
          pinSpacing: false,
          anticipatePin: 1,
          // markers: true,
        },
      });

      $(".accordion-tab button, .tab-button-wrap button").click(function (event) {
        ScrollTrigger.refresh(true);
      });
    }
  });
})(jQuery);
